import { splitSequenceSteps, stepLabel } from "@/pages/sequences/sequence-steps-preview";
import { pluralize } from "@/utils/text";
import type { ActionStep } from "./VideoDetail";

type SequenceStepLike = {
  step: number;
  type: string;
  delayDays: number;
  messageTemplateId: string | null;
  customMessage: string | null;
  branch?: "taken" | "not_taken" | null;
  branchCondition?: string | null;
};

type MessageTemplateLike = { id: string; content: string };

const stepToEntries = (step: SequenceStepLike, templates: MessageTemplateLike[]): ActionStep[] => {
  const entries: ActionStep[] = [];
  if (step.delayDays > 0) {
    entries.push({ text: `Wait ${pluralize(step.delayDays, "day", "days")}`, isSubtle: true });
  }
  const hasMessagePreview = !!(step.messageTemplateId || step.customMessage);
  const messageContent = step.messageTemplateId
    ? templates.find((t) => t.id === step.messageTemplateId)?.content
    : (step.customMessage ?? undefined);
  entries.push({ text: stepLabel(step), step: step.step, hasMessagePreview, messageContent });
  return entries;
};

export const stepsToActionSteps = (steps: SequenceStepLike[], templates: MessageTemplateLike[]): ActionStep[] => {
  const { trunk, branchStep, takenArm, notTakenArm, armLabels, check } = splitSequenceSteps(steps);

  const entries = trunk.flatMap((step) => stepToEntries(step, templates));
  if (!branchStep) return entries;

  if (branchStep.delayDays > 0) {
    entries.push({ text: `Wait ${pluralize(branchStep.delayDays, "day", "days")}`, isSubtle: true });
  }
  entries.push({ text: check?.title ?? "Check condition" });
  entries.push({ text: armLabels?.taken ?? "If true", isSubtle: true });
  entries.push(...takenArm.flatMap((step) => stepToEntries(step, templates)));
  entries.push({ text: armLabels?.notTaken ?? "If false", isSubtle: true });
  entries.push(...notTakenArm.flatMap((step) => stepToEntries(step, templates)));
  return entries;
};
